// import Single from "echarts/src/coord/single/Single";

export default {
  create_team: `Create Team`,
  team_name: `Team Name`,
  team_slug: `Team Slug`,
  team_members: `Team Members`,
  team_trial: `Team Trial`,
  member: `Member`,
  you_have_x_invitations_remaining: `You currently have {{count}} invitation(s) remaining.`,
  you_have_x_teams_remaining: `You currently have {{teamCount}} teams remaining.`,
  slug_input_explanation: `This slug is used to identify your team in URLs.`,
  plan_allows_no_more_teams: `Your current plan doesn't allow you to create more teams`,
  plan_allows_no_more_members: `Your current plan doesn't allow you to invite more members`,
  update_team_name: `Update Team Name`,
  team_name_was_updated: `Your team name has been updated!`,
  current_teams: `Current Teams`,
  leave_team: `Leave Team`,
  are_you_sure_you_want_to_leave_team: `Are you sure you want to leave this team?`,
  delete_team: `Delete Team`,
  are_you_sure_you_want_to_delete_team: `Are you sure you want to delete this team?`,
  if_you_delete_team_all_data_will_be_deleted: `If you choose to delete the team all data will be permanently deleted.`,
  team_photo: `Team Photo`,
  edit_team_member: `Edit Team Member`,
  remove_team_member: `Remove Team Member`,
  are_you_sure_you_want_to_delete_member: `Are you sure you want to remove this team member?`,
  teams: `Teams`,
  teams_currently_trialing: `Teams Currently Trialing`,
  we_found_invitation_to_team: `We found your invitation to the {{teamName}} team in {{organizationName}} organization!`,
  we_found_invitation_to_organization: `We found your invitation to the {{organizationName}} organization!`,
  wheres_your_team: `Where's Your Team?`,
  looks_like_you_are_not_part_of_team: `It looks like you're not part of any team!`,
  user_invited_to_join_team: `{{userName}} has invited you to join their team!`,
  please_upgrade_to_create_more_teams: `Please upgrade your subscription to create more teams.`,
  team_trial_will_expire_on: `The team's trial period will expire on {{date}}.`,
  you_have_been_invited_to_join_team: `You have been invited to join the {{teamName}} team!`,
  please_upgrade_to_add_more_members: `Please upgrade your subscription to add more team members.`,
  user_already_on_team: `That user is already on the team.`,
  user_already_invited_to_team: `That user is already invited to the team.`,
  user_doesnt_belong_to_team: `The user does not belong to the given team.`,
  not_eligible_based_on_current_members_teams: `You are not eligible for this plan based on your current number of teams / team members.`,
  saml2_idp_entity_id: `Entity ID`,
  saml2_idp_sos_url: `Single Sign-On Service URL`,
  saml2_idp_sls_url: `Single Logout Service URL`,
  saml2_idp_cert: `Certificate`,
  oauth2_client_id: `Client ID`,
  oauth2_client_secret: `Client secret`,
  not_a_team_member: `You are not a selected team member`,
  team_invitation: `Team Invitation`,
  domain_attached: '{{domain}} has been attached to {{team}}.',
  domain_detached: '{{domain}} has been detached from {{team}}.',

  menu: {
    membership: `Membership`,
    settings: `Team Settings`,
    profile: `Team Profile`,
    api: `API`,
    billing: `Team Subscription`,
    subscription: `Limits and Upgrades`,
    payment_method: `Payment Method`,
    invoices: `Invoices`,
    sso: `Single Sign-On`,
    usage: `Team Usage`,
  },

  title: {
    plan_options: `Limits and Upgrades`,
    select_plan: ``,
  },

  billing: {
    subscription: {
      default: {
        title: "Custom",
        name: "Custom",
        description: {
          long: "With a custom subscription, you have the freedom to choose the features and services that matter most to you, and only pay for what you need.",
          short: "tailored to your unique needs and preferences.",
        },
      },
      free: {
        title: `Plan Inclusions`,
        name: `Free`,
        description: `Free basic ad-supported shortening for basic team. Customize your links and keep track of your link history.`,
        descriptionShort: `basic ad-supported shortening for basic team.`,
      },
    },
  },

  sso: {
    provider: {
      azure: `Microsoft Azure`,
      okta: `Okta`,
      gsuite: `Google Workspace`,
      visualstudio: `Visual Studio`,
      microsoft: `Microsoft`,
    },

    type: {
      oauth2: `OAuth2`,
      saml2: `SAML2`,
    },
  },
};
